<template>
    <div name="banner" class="banner">
		<div ref="slider" class="section-wrap" @touchstart="startTouch" @touchend="endTouch"  @touchmove="moveTouch" @wheel="handleScroll">
            <div class="section section1">
                <div class="video-area">
                    <video autoplay muted loop playsinline class="bg-video">
                        <source src="../../assets/partners_mobile/partners_main_m.mp4" type="video/mp4">
                    </video>
                </div>
                <img class="logo" src="../../assets/partners_mobile/soldoc_logo.png" alt="soldoc+"/>
                <div class="title-area">
                    <h2 class="title">신환모객부터<br>매출상승까지<br>솔닥파트너스</h2>
                    <p class="sub-text">의료진 전용 올인원 솔루션<br>환자 CRM + 클라우드 EMR</p>
                    <a href="https://partner.soldoc.co.kr/" target="_blank" title="새 창 열림" class="btn-tele-main">
                        <span class="text">솔루션 가입하기</span>
                    </a>
                </div>      
                <button class="btn-section-mouse" title="다음으로 이동" @click="buttonMouse">
                    <img class="section-mouse" src="../../assets/partners_mobile/img_mouse_arrow.png" alt="">
                    <img class="mouse-arrow" src="../../assets/partners_mobile/img_chevron_down.png" alt="">
                </button>
            </div>
            <div class="section section2">
                <div class="section-inner">
                    <div class="text-area">
                        <strong>기존 EMR 교체 없이<br>함께 사용하세요</strong>
                        <p>솔닥 환자 진료는 솔닥 파트너스로.<br>이중 차팅의 번거로움 없이 관리할 수 있습니다.</p>
                    </div>
                    <div class="content-area logo-box-area">
                        <ul class="logo-box">
                            <li><img src="../../assets/partners_mobile/img_logo1.png" alt="의사랑" /></li>
                            <li><img src="../../assets/partners_mobile/img_logo2.png" alt="비트U차트" /></li>
                            <li><img src="../../assets/partners_mobile/img_logo3.png" alt="eghis" /></li>
                            <li><img src="../../assets/partners_mobile/img_logo4.png" alt="포인트닉스" /></li>
                            <li><img src="../../assets/partners_mobile/img_logo5.png" alt="엣지앤넥스트" /></li>
                            <li><img src="../../assets/partners_mobile/img_logo6.png" alt="오름차트" /></li>
                            <li><img src="../../assets/partners_mobile/img_logo7.png" alt="닥터팔레트" /></li>
                            <li><img src="../../assets/partners_mobile/img_logo8.png" alt="truedoc" /></li>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="section section3">
                <div class="section-inner">
                    <p class="text-area">솔닥파트너스로 만나는<br> <strong>놀라운</strong> 변화</p>
                </div>
            </div>
            <div ref="section4" class="section section4">
                <div class="section-inner">
                    <div class="text-area">
                        <h3>50만 솔닥 이용자<br> 우리 병원 고객이 됩니다</h3>
                    </div>
                    <ul class="content-area data-area">
                        <li>
                            <dl>
                                <dt>이용자 만족도</dt>
                                <dd>
                                    <strong ref="number1">00</strong>%
                                </dd>
                            </dl>
                            <p>솔닥 자체 VOC 집계 기준<br>(22' 3Q - 23' 4Q)</p>
                        </li>
                        <li>
                            <dl>
                                <dt>누적 진료 수</dt>
                                <dd>
                                    <strong ref="number2">00</strong>만+
                                </dd>
                            </dl>
                            <p>솔닥 누적 진료 중개 건 수<br>(22' 1Q - 23' 4Q)</p>
                        </li>
                        <li>
                            <dl>
                                <dt>동일병원 재진율</dt>
                                <dd>
                                    <strong ref="number3">00</strong>%
                                </dd>
                            </dl>
                            <p>솔닥 재진율<br>(22' 1Q - 23' 4Q)</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:'hero',
	data() {   
		return {
			currentIndex: 0,
			startY: 0,
			endY: 0,
			scrolling: false,
            maxNum1 : 94,
            maxNum2 : 59,
            maxNum3 : 85,
            currentNum1: 0,
            currentNum2: 0,
            currentNum3: 0,
            interval1: null,
            interval2: null,
            interval3: null,
            section4Visible: false,
            section4AnimationStarted: false,
            currentSectionIndex: 0,
		}
	},
	mounted() {
        document.addEventListener('touchmove', this.moveTouch, { passive: false });
        document.addEventListener('moveToSlide', this.moveToSlide);
        this.setVhProperty();
        window.addEventListener('resize', this.setVhProperty);

        const observer = new IntersectionObserver(this.handleIntersection, { threshold: 0.5 });
        observer.observe(this.$refs.section4);
	},
    beforeDestroy() {
        document.removeEventListener('touchmove', this.moveTouch);
        window.removeEventListener('resize', this.setVhProperty);
    },
    methods: {
        buttonMouse() {
            if (this.currentIndex < 3) {
                this.currentIndex++;
                this.updateSlider();
            }
        },
        scrollToPosition(position) {
            window.scrollTo({
                top: position,
                behavior: 'smooth'
            });
        },
        moveToSlide(event) {
            this.currentIndex = event.detail.index;
            this.updateSlider();
        },
        setVhProperty() {
            if (window.scrollY !== 0) return;
            let vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        },

		startTouch(event) {
            this.startY = event.touches[0].clientY;
        },
        moveTouch(event) {
            if (!event.cancelable) return;

            var moveY = event.touches[0].clientY;
            var diff = this.startY - moveY;
			
            if (window.scrollY !== 0) return;
            if (this.currentIndex === 3 && diff > 0) {
                return;
            }
            if (this.currentIndex === 0 && diff < 0) {
                return;
            }

            event.preventDefault();
        },
        endTouch(event) {
            this.endY = event.changedTouches[0].clientY;
            var diff = this.startY - this.endY;
            if (diff > 50 && this.currentIndex < 3) {
                this.currentIndex++;
                this.updateSlider();
            } else if (diff < -50 && this.currentIndex > 0) {
                this.currentIndex--;
                this.updateSlider();
            }
        },
		handleScroll(event) {
            if (this.scrolling) return;

            this.scrolling = true;
            setTimeout(() => {
                this.scrolling = false;
            }, 400);

            if (event.deltaY > 0 && this.currentIndex < 3) {
                event.preventDefault();
                this.currentIndex++;
            } else if (event.deltaY < 0 && this.currentIndex > 0) {
                event.preventDefault();
                this.currentIndex--;
            }
            this.updateSlider();
        },
        buttonClick() {
            if (this.currentIndex < 3) {
                this.currentIndex++;
                this.updateSlider();
            }
        },
        lastButtonClick() {
            const featureElement = document.getElementById('feature');
            const rect = featureElement.getBoundingClientRect();
            const absoluteTop = window.scrollY + rect.top;
            const targetPosition = absoluteTop + 84;
            window.scrollTo({
                top: targetPosition,
                behavior: 'smooth'
            });
        },
		updateSlider() {
            const vhInPixels = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--vh'));
            const pageHeightInPixels = 100 * vhInPixels;
            const translateYValue = this.currentIndex * pageHeightInPixels;
            var slider = this.$refs.slider;
            slider.style.transform = `translateY(-${translateYValue}px)`;

			if(this.currentIndex === 1) {
				$('.section2 .text-area').css('display', 'block');
				$('.section2 .logo-box-area').css('display', 'block');
                $('.section2 .ani').addClass('start-ani');
			} else {
				$('.section2 .text-area').css('display', 'none');
				$('.section2 .logo-box-area').css('display', 'none');
                $('.section2 .ani').removeClass('start-ani');
			}
			if(this.currentIndex === 2) {
				$('.section3 .text-area').css('display', 'block');

			} else {
				$('.section3 .text-area').css('display', 'none');
			}
			if(this.currentIndex === 3) { 
				$('.section4 .text-area').css('display', 'block');
				$('.section4 .data-area').css('display', 'flex');
                $('.section-wrap').addClass('off');
			} else {
				$('.section4 .text-area').css('display', 'none');
				$('.section4 .data-area').css('display', 'none');
                $('.section-wrap').removeClass('off');
			}
        },
        startAnimation(ref, maxNum, currentNumVar, intervalVar) {
            const intervalDuration = 25;
            const totalSteps = 100;
            const stepValue = maxNum / totalSteps;

            this[intervalVar] = setInterval(() => {
            const element = this.$refs[ref];
            if (element) {
                if (this[currentNumVar] < maxNum) {
                    this[currentNumVar] += stepValue;
                    element.innerText = this[currentNumVar].toFixed(0);
                } else {
                    clearInterval(this[intervalVar]);
                    element.innerText = maxNum;
                }
            } else {
                clearInterval(this[intervalVar]);
            }}, intervalDuration);
        },
        
        handleIntersection(entries) {
            entries.forEach(entry => {
                if (entry.isIntersecting && !this.section4AnimationStarted) {
                    this.startAnimation("number1", this.maxNum1, "currentNum1", "interval1");
                    this.startAnimation("number2", this.maxNum2, "currentNum2", "interval2");
                    this.startAnimation("number3", this.maxNum3, "currentNum3", "interval3");
                }
            });
        },
    }
}
</script>

<style scoped>
    .banner {
		position: relative;
		display: flex; 
		flex-direction: column;
		justify-content: flex-start;
		align-items: center;
		width: 100%;
        height: calc(100 * var(--vh));
        max-height: calc(100 * var(--vh));
		overflow: hidden;
    }
    .section-wrap {
        width: 100%;
		transform: translateY(0%);
        transition: transform 0.3s ease-in-out;
    }
    .section-wrap.off {
        position: fixed;
    }
    .section1 .logo {
		position: absolute;
		top: 33px;
        left: calc(50% - 35.5px);
        width: 71px;
	}
    .section {        
        position: relative;
        display: block;
        width: 100%;
        height: 100%;
        height: calc(100 * var(--vh));
        overflow: hidden;
    }
    .bg-video {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    .video-area {
        z-index: -1;
        position: absolute;
		width: 100%;
		height: 100%;
    }
    .video-area::after {
        content: "";
        position: fixed;
        top: 0;
        left: 0;
        display: block;
        width: 100%;
        height: 100%;
        background: #000;
        opacity: 0.4;
    }
    .title-area {
        position: relative;
        top: 50%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        transform: translateY(-50%);
    }
    .title {
        margin-bottom: 0;
        font-size: 32px;
        font-weight: 600;
        color: #fff;
        text-align: center;
        line-height: 44px;
        animation: fadeInUp 1s;
    }
    .sub-text {
        display: inline-block;
        margin-top: 18px;
        margin-bottom: 0;
        font-size: 18px;
        font-weight: 400;
        color: #FFF;
        text-align: center;
        line-height: 28px;
        animation: fadeInUp 1.5s;
    }
    .btn-tele-main {
        display: flex;
        justify-content: space-around;
        align-items: center;   
        width: 150px;
        height: 46px;
        margin-top: 32px;
        padding-top: 1px;
        padding-left: 19.66px;
        padding-right: 19.66px;
        border-radius: 6px;
        background: #008DEF;
        font-weight: 500;
        font-size: 16px;
        color: #fff;
		line-height: 1;
		text-decoration: none;
		animation: fadeInUp 1s;
    }
	.btn-tele-main .text {
        position: relative;
    }
    .btn-tele-main:hover {
        background: #fff;
		color: #008DEF;
    }
    .btn-section-mouse {
        position: absolute;
        left: 50%;
        bottom: 15px;
        transform: translate(-50%);
        display: flex;
        flex-direction: column;
        width: 22px;
        height: 59px;
        margin: 0;
        padding: 0;
        background: none;
        border: none;
        z-index: 20;
    }
    .section-mouse {
        position: relative;
        display: block;
        width: 22px;
        height: 34px;
        height: auto;
    }
    .mouse-arrow {
        display: block;
        width: 22px;
        height: 22px;
        margin-top: 9px;
        transform-origin: 0px 0px;
        transform: translate(0, 0);
        animation: scroll-down 900ms ease-in-out infinite;
    }
    @keyframes scroll-down {
        0% {
        transform: translate(0, 3px);
        }
        30% {
        transform: translate(0, -2px);
        }       
        45% {
        transform: translate(0, 3px);
        }
        100% {
        transform: translate(0, 3px);
        }
    }
    @keyframes fadeInUp {
        0% {
            opacity: 0;
            transform: translate3d(0, 100%, 0);
        }
        to {
            opacity: 1;
            transform: translateZ(0);
        }
    }

    .section2 {
        width: 100%;
        background: #000;
    }
    .section2 .section-inner {    
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;        
        width: 100%;
        height: 100%;
        /* margin: 0 auto; */
        padding: 21% 5px 5%;
    }
    .section2 .text-area {
		animation: fadeInUp 1s;
    }
    .section2 .text-area strong {
        display: block;
        font-size: 30px;
        font-weight: 600;
        line-height: 42px;
        color: #FFF;
        text-align: center;
    }
    .section2 .text-area p {
        display: block;
        margin-top: 22px;
        margin-bottom: 95px;
        font-size: 16px;
        font-weight: 400;
        line-height: 26px;
        color: #FFF;
        text-align: center;
    }
    .section2 .logo-box-area .logo-box {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        width: 268px;
        list-style: none;
        padding: 0;
        margin: 0;
		animation: fadeInUp 1s;
    }
    .section2 .logo-box-area .logo-box li {
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        width: calc(50% - 4px);
        height: 56.5px;
        margin-bottom: 4px;
        border-radius: 10px;
        background: #FFF;
    }
    .section2 .logo-box-area .logo-box li:nth-child(n+11) {
        margin-bottom: 0;
    }
    .section2 .logo-box-area .logo-box li img {
        display: inline-block;
    }
    .section2 .logo-box-area .logo-box li:nth-child(n+9):nth-child(-n+10) {
        opacity: 0.5 !important;
    }
    .section2 .logo-box-area .logo-box li:nth-child(n+11):nth-child(-n+12) {
        opacity: 0.2 !important;
        background: linear-gradient(180deg, #FFF 0%, rgba(255, 255, 255, 0.00) 100%) !important;
    }
    .ani {
        position: absolute;
    }
    .start-ani {
        animation: slideUp 12s linear infinite;
    }
    .ani-content {
        display: flex;
        flex-direction: column;
    }
    .ani-content span {
        display: inline-block;
        width: 250px;
        height: 1.48em;
        line-height: 1.5;
        text-align: center;
    }

    .section3 {
        width: 100%;
        background: #000;
    }
    .section3 .section-inner {    
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        margin: 0 auto;
    }
    .section3 .section-inner p,
    .section3 .section-inner strong {
        margin-bottom: 0;
        font-size: 30px;
        font-weight: 600;
        line-height: 46px;
        color: #FFF;
        text-align: center;
    }
    .section3 .section-inner p {
        animation: fadeInUp1 2s;
    }
    .section3 .section-inner strong {
        position: relative;
    }
    .section3 .section-inner strong::before {
        content: '';
        position: absolute;
        top: -5px;
        left: -13px;
        width: 4px;
        height: 4px;
        border-radius: 50%;
        box-shadow: 25px 0 0 0 #008DEF, 50px 0 0 0 #008DEF, 75px 0 0 0 #008DEF;
    }
    
    .section4 {
        width: 100%;
        background: #000;
    }
    .section4 .section-inner {    
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        margin: 0 auto;
    }
    .section4 .text-area {
        text-align: center;
        animation: fadeInUp1 2s;
    }
    .section4 .text-area h3 {
        margin-bottom: 0;
        font-size: 30px;
        font-weight: 600;
        line-height: 42px;
        color: #FFF;
    }
    .section4 .data-area {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        gap: 32px;
        list-style: none;
        width: 100%;
        padding: 0;
        margin: 49px 0 0;
        animation: fadeInUp1 2s;
    }
    .section4 .data-area dl {
        display: flex;
        flex-direction: column-reverse;
        align-items: center;
        margin-bottom: 0;
    }
    .section4 .data-area dt {
        text-align: center;
        font-size: 18px;
        font-weight: 600;
        line-height: 42px;
        color: #008DEF;
    }
    .section4 .data-area dd {
        margin-bottom: 0;
        text-align: center;
        font-size: 60px;
        font-weight: 700;
        line-height: 60px;
        color: #FFF;
    }
    .section4 .data-area p {
        margin-bottom: 0;
        text-align: center;
        font-size: 12px;
        font-weight: 400;
        line-height: 18px;
        color: #999;
    }
    
    @keyframes fadeUp {
        0% {
            opacity: 0;
            transform: translate3d(0, 30%, 0);
        }
        to {
            opacity: 1;
            transform: translateZ(0);
        }
    }
    @keyframes fadeUp2 {
        0% {
            opacity: 0;
            transform: translate3d(0, 200%, 0);
        }
        to {
            opacity: 1;
            transform: translateZ(0);
        }
    }
    @keyframes slideUp {
        0%, 10% {
            top: 0;
        }
        25%, 40% {
            top: -1.48em;
        }
        55%, 70% {
            top: -2.96em;
        }
        85%, 99.98% {
            top: -4.44em;
        }
        99.99%, 100% {
            top: 0;
        }
    }
    @keyframes fadeInUp1 {
        0% {
            opacity: 0;
            transform: translate3d(0, 200%, 0);
        }
        to {
            opacity: 1;
            transform: translateZ(0);
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/mobile_partners/Banner.vue